export enum KeyInitiativeInitTypes {
  ImportedInitiative = 'jbp-capabilities-pillar',
}
